import React, { forwardRef } from 'react';

import { ButtonBaseProps, ButtonBase } from '@material-ui/core';

export const STIButtonbase: React.FC<ButtonBaseProps<'div'>> = forwardRef(({ children, ...props }, ref) => (
    <ButtonBase component="div" {...props} ref={ref}>
        {children}
    </ButtonBase>
));
